import { apiHelper } from '@/utils';
import { API } from '@/constants';

export const workgroupService = {
    getAll,
    store,
    show,
    update,
    updateStatus,
};

const MODULE = {
    WORKGROUP: 'workgroups',
};

const API_URL = API.BASE_URL_API + '/v1';

export function getAll (filter) {
    const request = {
        params: {
            usage_type: filter?.usageType ?? 2, // default as 2 (orientation)
            page: filter?.pageNumber,
            size: filter?.pageSize,
            is_active: filter?.isActive,
        },
    };

    let array = filter?.searchArray;
    array?.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`;
            request.params[searchParam] = word;
        }
    });

    return apiHelper(API_URL).get(`/${MODULE.WORKGROUP}`, request);
}

export function store (data) {
    const request = {
        name: data.name,
        usage_type: data.usageType ?? 2, // default as 2 (orientation)
        users: (data.users ?? []).map(user => ({
            uuid: user.uuid,
            is_admin: user.isAdmin,
        })),
    };

    return apiHelper(API_URL).post(`/${MODULE.WORKGROUP}`, request);
}

export function show (uuid) {
    return apiHelper(API_URL).get(`/${MODULE.WORKGROUP}/${uuid}`);
}

export function update (data) {
    const request = {
        name: data.name,
        usage_type: data.usageType ?? 2, // default as 2 (orientation)
        users: (data.users ?? []).map(user => ({
            uuid: user.uuid,
            is_admin: user.isAdmin,
        })),
    };

    return apiHelper(API_URL).put(`/${MODULE.WORKGROUP}/${data.uuid}`, request);
}

export function updateStatus (data) {
    const request = {
        is_active: data.isActive,
    };

    return apiHelper(API_URL).patch(`/${MODULE.WORKGROUP}/${data.uuid}`, request);
}